import React from "react";
import develop from "../assets/aboutus/develop.png"
import timecross from "../assets/aboutus/timecross.png"
import teamintro from "../assets/aboutus/teamintro.png"
import tri1 from "../assets/aboutus/triangle1.png"
import tri2 from "../assets/aboutus/triangle2.png"


import { timeLine } from "./constants"
import "./index.scss"

class AboutUs extends React.Component {

    componentDidMount() {
        const dom = document.getElementsByClassName(this.props.location.state?.target)[0]
        dom && dom.scrollIntoView()
        this.setState({ target: this.props.location.state?.target })
    }

    componentDidUpdate() {
        if (!this.props.location.state) return;
        if (this.props.location.state?.target !== this.state.target) {
            this.setState({ target: this.props.location.state.target })
            document.getElementsByClassName(this.props.location.state.target)[0].scrollIntoView()
        }
    }

    renderTL() {
        let tlDOM = timeLine.map(ele => {
            return (
                <li className="tl-item" key={ele.year}>
                    <div className="left">
                        <div className="year-wrap">
                            <div className="year-left">
                                <div className="year-circle"><div className="year-round"><span className="year-wrap">{ele.year}</span></div></div>
                            </div>
                            <div className="year-line"></div>
                            <div className="year-line-end"></div>
                        </div>
                    </div>
                    <div className="right">{ele.compishment}</div>
                </li>
            )
        })

        return tlDOM;
    }

    render() {
        return (
            <div className="about-us">
                <div className="about-part-1">
                    <div className="part-1-bg"></div>
                    <div className="about-title">
                        <h1>关于我们</h1>
                        <p>国际一流的脑科学产品研发与落地团队，致力于脑医学与脑健康领域的前沿探索。</p>
                    </div>
                    <div className="about-part-1-info">
                        <div class="ours-section-wrap">
                            <div class="ours-section">
                                <h3>我们的愿景<span className="section-title-en">VISION</span></h3>
                                <p>慧脑云成立于2018年，秉持“服务脑疾病精准医疗、支撑脑健康个体监测”的目标，公司始终与脑疾病方面的临床医生以及脑科学领域的科研工作者并肩前行，走在临床与科研的最前沿。公司将始终坚持跨领域的科技创新，与广阔的脑医学与脑健康市场共同成长。</p>
                            </div>
                            <div class="ours-section">
                                <h3>我们的技术<span className="section-title-en">TECHNOLOGY</span></h3>
                                <p>公司总部设立在北京与中国科学技术大学合肥综合性国家科学中心人工智能研究院开展了深度合作，核心团队来自北京大学、中科院、加拿大麦吉尔大学等脑科学与人工智能领域知名机构。</p>
                            </div>
                            <div class="ours-section">
                                <h3>我们的服务<span className="section-title-en">SERVICE</span></h3>
                                <p>基于多模态磁共振脑成像、脑电图和脑磁图等脑成像前沿技术，融合大数据、云计算以及人工智能领域的核心算法，慧脑云对个体化的脑重大疾病精准诊疗、个体化的脑健康监测、脑科学的前沿基础研究与临床应用提供全方位技术支撑和全流程解决方案。</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="about-part-2">
                    <div className="part-title-wrap">
                        <div className="part-title">
                            <img className="develop" src={develop}></img>
                            <img className="time-cross" src={timecross}></img>
                        </div>
                    </div>
                    <div className="part-content">
                        <ul className="tl-wrap">{this.renderTL()}</ul>
                    </div>
                </div>
                <div className="about-part-3">
                    <img src={tri1} className="triangle1" />
                    <img src={tri2} className="triangle2" />
                    <div className="part-content">
                        <div className="word-wrap">
                            <img className="title" src={teamintro}></img>
                            <div className="introduction">依托跨学科融合的不断创新是公司发展的源动力与护城河，公司汇聚了脑科学与人工智能领域的顶级专家学者与技术精英，核心团队来自北京大学、中科院、加拿大麦吉尔大学等脑科学与人工智能领域国内外著名学府，是多项国家重大课题的课题骨干。</div>
                        </div>
                        <div className="img-wrap">
                            <div className="intro1"><p className="img-descriotion">慧脑云汇集了脑科学领域的科学家和年轻学者。</p></div>
                            <div className="intro23-wrap">
                                <div className="intro2"><p className="img-descriotion">慧脑云汇集了脑科学领域的科学家和年轻学者。</p></div>
                                <div className="intro3"><p className="img-descriotion">慧脑云汇集了脑科学领域的科学家和年轻学者。</p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AboutUs;